import React from 'react'
import { ErrorMessage } from 'formik'
import ErrorRow from './ErrorRow'
import classNames from 'classnames'
import SelectNormal from '../../select/SelectNormal'

/**
 * 
 * @param {object} field
 * @description contain { onChange, onBlur, name, value }
 * @link https://jaredpalmer.com/formik/docs/api/useField#fieldinputpropsvalue 
 * 
 * @param {object} meta
 * @description contain { value, touched, error, initialValue }
 * @link https://jaredpalmer.com/formik/docs/api/useField#fieldmetapropsvalue
 * 
 * @param {object} form
 * 
 */
export const Select = ({
    field,
    form,
    label,
    children,
    wrappedComponent: Component = SelectNormal,
    customError: ErrorComponent,
    groupClassName,
    className,
    absolutError = false,
    onValueChange,
    ...props
}) => {
    const { name } = field;
    const { disabled = false } = props;
    const isValid = !(form.errors[name] && form.touched[name]);
    const value = props.options ? props.options.find(option => option?.value === field?.value) : '';
    const onChange = option => {
        const optionValue = form.setFieldValue(name, option?.value);
        if (typeof onValueChange === 'function') onValueChange(optionValue)
        return optionValue
    }
    
    return (
        <div className={classNames(
            "form-group", 
            groupClassName, 
            { 
                'form-error': !isValid, 
                'form-disabled': disabled,
                'absolut-error': absolutError
            }
        )}>
            <div className="form-info">
                <label htmlFor={name}>{label}</label>
                {ErrorComponent ?
                    <ErrorComponent /> :
                    <ErrorMessage name={name} component={ErrorRow} />}
            </div>
            <Component 
                {...field} 
                {...props} 
                classNamePrefix="react-select"
                className={classNames("react-select", className)}
                value={value}
                onChange={onChange}
            />
        </div>
    )
}
